import ChangelogView from '../../features/footer/changelog-view';

export default function ChangelogPage() {
    return <ChangelogView />;
}
